import { createContext, ReactNode, useMemo } from 'react';

export interface NavigationItemContextValues {
  orientation: 'horizontal' | 'vertical';
  selectionManagedByTabs?: boolean;
  setSelectedValue?: (value: unknown, active: boolean) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const NavigationItemContext = createContext<NavigationItemContextValues>({
  orientation: 'horizontal',
});

export function NavigationItemProvider({
  orientation,
  selectionManagedByTabs,
  setSelectedValue,
  children,
}: {
  orientation: NavigationItemContextValues['orientation'];
  selectionManagedByTabs?: NavigationItemContextValues['selectionManagedByTabs'];
  setSelectedValue?: NavigationItemContextValues['setSelectedValue'];
  children: ReactNode;
}) {
  const contextValue = useMemo(
    () => ({ orientation, selectionManagedByTabs, setSelectedValue }),
    [orientation, selectionManagedByTabs, setSelectedValue],
  );
  // eslint-disable-next-line react/no-context-provider
  return <NavigationItemContext.Provider value={contextValue}>{children}</NavigationItemContext.Provider>;
}
